const initialWebsiteSwitchState = {
  landedOnLocation: '',
  websiteHasBeenChosen: false,
  currentWebsite: '',
  currentWebsiteSettings: {
    assignPageFeature: false,
  },
  currentWebsiteCredentials: null,
  allWebsites: [],
};

const websiteSwitchActions = {
  WEBSITE_SWITCH_SET_ALL: 'WEBSITE_SWITCH_SET_ALL',
  SET_HAS_WEBSITE_BEEN_CHOSEN: 'SET_HAS_WEBSITE_BEEN_CHOSEN',
  SET_CURRENT_WEBSITE: 'SET_CURRENT_WEBSITE',
  SET_CURRENT_WEBSITE_CREDENTIALS: 'SET_CURRENT_WEBSITE_CREDENTIALS',
  SET_ALL_WEBSITES: 'SET_ALL_WEBSITES',
  CLEAN_WEBSITE_SWITCH: 'CLEAN_WEBSITE_SWITCH',
  CLEAN_WEBSITE_CHOSEN: 'CLEAN_WEBSITE_CHOSEN',
};

function websiteSwitchReducer(state, action) {
  switch (action.type) {
    case websiteSwitchActions.WEBSITE_SWITCH_SET_ALL:
      if (action.payload.currentWebsiteSettings) {
        return {
          ...state,
          ...action.payload,
          currentWebsiteSettings: {
            ...state.currentWebsiteSettings,
            ...action.payload.currentWebsiteSettings,
          },
        };
      }
      return { ...state, ...action.payload };
    case websiteSwitchActions.SET_HAS_WEBSITE_BEEN_CHOSEN:
      if (action.payload.websiteHasBeenChosen === false) {
        return {
          ...state,
          currentWebsite: '',
          websiteHasBeenChosen: action.payload.websiteHasBeenChosen,
        };
      }
      return { ...state, websiteHasBeenChosen: action.payload.websiteHasBeenChosen };
    case websiteSwitchActions.SET_CURRENT_WEBSITE:
      return {
        ...state,
        websiteHasBeenChosen: true,
        currentWebsite: action.payload.currentWebsite,
      };
      case websiteSwitchActions.SET_CURRENT_WEBSITE_CREDENTIALS:
        return {
          ...state,
          currentWebsiteCredentials: action.payload.currentWebsiteCredentials,
        };
    case websiteSwitchActions.SET_ALL_WEBSITES:
      return { ...state, allWebsites: action.payload.allWebsites };
    case websiteSwitchActions.CLEAN_WEBSITE_SWITCH:
      return { ...state, ...initialWebsiteSwitchState };
    case websiteSwitchActions.CLEAN_WEBSITE_CHOSEN:
      return {
        ...state,
        websiteHasBeenChosen: false,
        currentWebsite: '',
        currentWebsiteSettings: {
          assignPageFeature: false,
        },
      };
    default:
      return state;
  }
}

export { initialWebsiteSwitchState, websiteSwitchActions, websiteSwitchReducer };
